namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoTypeColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoType';
    }
}
